'use client'
import { TRIPS_HEADINGS, VEHICLE_HEADINGS } from "../../utils/constants";
import TableHeader from "../../components/table_header";
import { Trip } from "../../utils/types";
import { useNavigate } from "react-router-dom";
import { dateFormat, formatNumber, getTripStatusBadge } from "../../utils/utils";
import RequestStatusBadge from "components/request_status";


const TripsTable = (props: any) => {
 const navigate = useNavigate()
  return (
    
      <table className="w-full text-left p-2 mx-auto border">
        <TableHeader data={TRIPS_HEADINGS} />
        <tbody className="w-full text-sm">
          {props.data && props.data.length > 0 ? props.data.map((row:Trip) => {
            
            return (
              <tr key={row.id} className="text-sm border-b border-b-gray-200 py-8 hover:bg-gray-100 cursor-pointer px-2 items-start" onClick={()=>{navigate(`/trips/view/${row.id}`,{state:{trip:row}})}}>
                <td className="border-bottom px-1 py-2">{row.vehicle_detail?.pnumber}
                </td>
                <td className="border-bottom px-1 py-2">{`${row.driver_detail?.fname}`}
                </td>
                {/* <td className="border-bottom px-1 py-2">{row.nameOfRequestor}
                </td> */}
                <td className="border-bottom px-1 py-2">{`${row.start_location}`}</td>
                <td className="border-bottom px-1 py-2">{row.destination}
                </td>
                <td className="border-bottom px-1 py-2">{row.end_mileage ? formatNumber(row.end_mileage - row.start_mileage): 'N/A'}
                </td>
                <td className="border-bottom px-1 py-2">{row.request?.project}
                </td>
                <td className="border-bottom px-1 py-2">{row.request?.fundcode}
                </td>
                <td className="border-bottom px-1 py-2">{dateFormat(row.date_created)}
                </td>
                <td className="border-bottom px-1 py-2"><RequestStatusBadge status={getTripStatusBadge(row.status)} className="justify-start"/>
                </td>
                
              </tr>
            )
          }):<tr><td className="my-4 text-1xl text-center" colSpan={9}> No Trips</td></tr>}
        </tbody>
      </table>
      )

};
export default TripsTable;
